import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { environment } from 'src/environments/environment';

@Injectable({
  providedIn: 'root',
})
export class BusinessFieldsService {
  private iContactBaseUrl: string;

  constructor(private http: HttpClient) {
    const config = environment;
    this.iContactBaseUrl = config.apiContactAdminBaseUrl;
  }

  public fetchBusinessFields(): Observable<string[]> {
    return this.http.get<string[]>(`${this.iContactBaseUrl}/Global/secteurActivites`);
  }
}
